import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ChevronLeft } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function BloomRules() {
  const [rules, setRules] = useState(null);
  useEffect(() => {
    fetch(`${BACKEND_URL}/api/bloom/rules`).then((r) => r.json()).then(setRules);
  }, []);

  return (
    <div className="bg-cream-light min-h-screen py-12" data-testid="bloom-rules-page">
      <div className="max-w-3xl mx-auto px-6">
        <Link to="/" className="inline-flex items-center gap-1 text-navy/60 hover:text-navy text-sm mb-6">
          <ChevronLeft size={16} /> Back to home
        </Link>
        <div className="flex items-center gap-3 mb-6">
          <div className="bg-pink-100 rounded-2xl p-3">
            <Sparkles className="text-pink-600" size={28} />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-navy">Bloom Attribution Sweepstakes — Official Rules</h1>
            <p className="text-navy/60 text-sm">Included free with every Advecti wrap campaign.</p>
          </div>
        </div>

        {!rules ? (
          <p className="text-navy/50">Loading…</p>
        ) : (
          <div className="bg-white rounded-2xl shadow-sm p-8 space-y-6" data-testid="bloom-rules-content">
            <section>
              <h2 className="font-bold text-navy mb-2">1. Sponsor</h2>
              <p className="text-navy/80 text-sm">{rules.sponsor}. Contact: ryanalbanese@advectigroup.com.</p>
            </section>
            <section>
              <h2 className="font-bold text-navy mb-2">2. Eligibility</h2>
              <p className="text-navy/80 text-sm">{rules.eligibility}</p>
            </section>
            <section>
              <h2 className="font-bold text-navy mb-2">3. How to Enter</h2>
              <ol className="list-decimal list-inside text-navy/80 text-sm space-y-1">
                {rules.how_to_enter.map((step, i) => <li key={i}>{step}</li>)}
              </ol>
              <p className="text-navy/60 text-xs mt-2">
                No purchase necessary. Void where prohibited. Limit one entry per Instagram
                account per drawing (plus up to {rules.max_bonus_entries} bonus entries via
                additional friend tags in the same comment).
              </p>
            </section>
            <section>
              <h2 className="font-bold text-navy mb-2">4. Drawing Schedule</h2>
              <p className="text-navy/80 text-sm">{rules.drawing}</p>
            </section>
            <section>
              <h2 className="font-bold text-navy mb-2">5. Prize</h2>
              <p className="text-navy/80 text-sm">
                {rules.prize}
                {!rules.prize_description && ` Approximate retail value: $${rules.prize_amount_usd}.`}
              </p>
            </section>
            <section>
              <h2 className="font-bold text-navy mb-2">6. Winner Selection & Notification</h2>
              <p className="text-navy/80 text-sm">
                Winners are drawn at random from all eligible entries at the end of each {rules.cycle_days}-day cycle.
                Entries are weighted by the number of friend tags in the qualifying comment.
                Advecti will notify the featured advertiser, who will contact the winner via
                Instagram direct message within seven (7) days of the drawing.
              </p>
            </section>
            <section>
              <h2 className="font-bold text-navy mb-2">7. General Conditions</h2>
              <p className="text-navy/80 text-sm">
                By entering, participants release Instagram, Meta Platforms, Inc., the sponsor,
                and the featured advertiser from any and all liability. Participants also grant
                the sponsor and featured advertiser the right to use their Instagram handle
                for winner announcement purposes.
              </p>
            </section>
            <section className="border-t border-navy/10 pt-6">
              <p className="text-navy/60 text-xs italic">{rules.disclaimer}</p>
            </section>
          </div>
        )}
      </div>
    </div>
  );
}
